<ion-app>
  <div
    class="app-root-container"
    [class.update-available]="updateAvailable"
    [style.--update-nudge-offset.px]="updateAvailable ? 48 : 0"
  >
    @if (isReady && appDisabled) {
      <div class="version-block-container">
        <div class="version-block-logo">
          <img src="assets/icon/logo.png" alt="" />
        </div>
        <h1>{{ 'app-update.update-required' | translate }}</h1>
        <p>{{ 'app-update.update-message' | translate }}</p>
        <ion-button (click)="updateApp()">{{ 'app-update.update-button' | translate }}</ion-button>
      </div>
    }

    @if (isReady && updateAvailable) {
      <div class="update-nudges-overlay">
        <div class="update-nudge" (click)="updateApp()">
          <span>{{ 'app-update.update-app-minor' | translate }}</span>
        </div>
      </div>
    }

    @if (isReady && !appDisabled) {
      <app-loader [visible]="loading" [message]="'loading-service.busy-please-wait' | translate"></app-loader>
      <ion-split-pane contentId="main-content" when="always">
        @if (environment.showDevSideMenu) {
          <app-main-menu></app-main-menu>
        }
        <ion-router-outlet id="main-content"></ion-router-outlet>
      </ion-split-pane>
    }
  </div>
</ion-app>
